import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { splitPrice } from "@/utils/price.utils";
import { getTagIdFor } from "@/utils/tagging/tag.utils";

import { useDeliveryItemContext } from "./context/deliveryItem.context";

export const formatPriceForEcommerce = (price: number) => {
    const splitted = splitPrice(price);
    return `${splitted[0]},${splitted[1] === "00" ? "-" : splitted[1]}`;
};

type Props = {
    className?: string;
    children: ReactNode;
};

const DeliveryItemBase = ({ className, children }: Props) => {
    const { option } = useDeliveryItemContext();
    return (
        <div
            className={cn(className)}
            {...getTagIdFor("pdp-delivery", option.deliveryType)}
        >
            {children}
        </div>
    );
};

export { DeliveryItemBase };
